// extracted by mini-css-extract-plugin
export default {"descriptionGroup":"EmailVerificationForm_descriptionGroup__nBVRG","helpLink":"EmailVerificationForm_helpLink__-Ct-i","resendButton":"EmailVerificationForm_resendButton__Mjz8X"};